import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@planningcenter/tapestry-react'

const Error = (props) => {
  const { message, children, className } = props

  if (message !== null && message !== undefined) {
    return (
      <div className="d-f ai-c jc-c py-1">
        <div class="alert alert--danger">
          <Icon
            className="symbol"
            name="general.exclamationTriangle"
            size="md"
          />

          <div class="alert__content">
            <p>{message}</p>
          </div>
        </div>
      </div>
    )
  }

  return <div className={className}>{children}</div>
}

Error.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
}

export default Error
